import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { colors } from "../../../Shared/colors";
import { DataGrid } from "@mui/x-data-grid";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import StarIcon from "@mui/icons-material/Star";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShareIcon from "@mui/icons-material/Share";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { useAssignLeadsMutation, useProjectassignMutation, useShareLeadMutation, useSingleassignLeadMutation } from "../../../features/leadsSlice";
import {
  useAddFavouriteMutation,
  useGetSingleHierarchyQuery,
  useGetActiveStaffQuery,
} from "../../../features/employeeSlice";
import { Toaster, toast } from "react-hot-toast";
import { Loader } from "../../../Shared/Loader";
import { Puff } from "react-loader-spinner";
import {
  useGetAllProjectsQuery,
  useGetSingleProjectQuery,
} from "../../../features/projectSlice";
import { useLazyGetInventoryByProjectIdQuery } from "../../../features/InventorySlice";
import { useAddNewTaskLeadIdMutation } from "../../../features/taskSlice";
import { UnifiedTaskTable } from "../../Telesales/Telesaleleads/Telesalesearchleads/UnifiedTaskTable";
import Tooltip from "@mui/material/Tooltip";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Banks } from "../../../Shared/Banks";
import { FeedbackTable } from "./FeedbackTable";
import moment from "moment";
import { Checkbox, FormControlLabel } from "@mui/material";
import { assignLeadNotification, unSubLeadAssigned } from "../../../services/socket";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { decryptData } from "../../../services/crypto";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { AddToCMPModal } from "./AddToCMPModal";
import { useLazyCheckLeadInCMPQuery } from "../../../features/cmpSlice";
export const SearchLeadsDataTable = ({ leads, currentPage, pageSize, setPageSize, setPage, isFetching, handleCheckboxChange, checked }) => {

  const [popUp, setpopUp] = useState(false);
  const [leadId, setleadId] = useState("");
  const [leadNumber, setLeadNumber] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [leadIdSm, setleadIdSm] = useState("");
  const [multileadId, setmultileadId] = useState([]);
  const [subType, setsubType] = useState();
  const [tokenDownPayment, settokenDownPayment] = useState(false);
  const [loading, setloading] = useState(false);
  const [closedLost, setclosedLost] = useState(false);
  const [addTask, { isLoading }] = useAddNewTaskLeadIdMutation();
  const [taskPopUp, setTaskPopUp] = useState(false);
  const [feedbackPopup, setfeedbackPopup] = useState(false)
  const [feedbackData, setfeedbackData] = useState([])
  const [leadSharePopUp, setleadSharePopUp] = useState(false);
  const [cmpModalOpen, setCmpModalOpen] = useState(false);
  const [selectedLeadForCMP, setSelectedLeadForCMP] = useState(null);
  const [checkLeadInCMP] = useLazyCheckLeadInCMPQuery();
  const [singleAssignpopup, setsingleAssignpopup] = useState(false);
  const [leadsSharedPopUp, setleadsSharedPopUp] = useState(false);
  const [leadShareData, setleadShareData] = useState({
    sharingEmployee: { label: "", id: "" },
    percentage: ""
  })
  const [Singleleadassign, setSingleleadassign] = useState({
    assignEmployee: { label: "", id: "" },

  })
  const [leadSharedData, setleadSharedData] = useState({
    assignEmployee: [],
  })
  const [projectassign, setprojectassign] = useState(null);
  const [projectpopup, setprojectpopup] = useState(false);
  const [numberPopUp, setnumberPopUp] = useState(false);
  const [phoneData, setphoneData] = useState([]);
  const [doNothing, setdoNothing] = useState(false);
  let { data: project } = useGetAllProjectsQuery();
  const projectOptions = project?.map((proj) => ({
    label: proj.projectName,
    value: proj._id,
  })) || [];

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
        setTaskPopUp(false);
        setnumberPopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const today = moment();
  const defaultDate = today.format('YYYY-MM-DDTHH:mm');
  const newMinDate = today.clone().subtract(1, 'days').format('YYYY-MM-DDTHH:mm');

  const [selectedProject, setSelectedProject] = useState("");
  const [task, settask] = useState({
    currentTaskType: "",
    currentSubTypeTask: "",
    completedDate: defaultDate,
    reason: "",
    comment: "",
    nextTaskType: "",
    deadline: "",
    DProjectID: "",
    DTprojectBlockName: "",
    invenID: "",
    developername: "",
    ammount: 0,
    paymentMode: "",
    bankName: "",
    transactionNo: 0,
    totalAmount: 0,
    leadStatus: "",
    // depositeDate: "",
    status: "",
    attachment: "",
    approvedPayment: "",
    cnicfront: "",
    cnicback: "",
    personalimage: "",
    leadId: "",
    clientId: "",
    clientname: "",
    cnic: "",
    phoneNo: "",
    nationality: "",
    address: "",
  });



  let { data: singleProject } = useGetSingleProjectQuery(task.DProjectID);

  let [shareLead, { isLoading: leadShareLoading }] = useShareLeadMutation();

  let [assignLeads, { isLoading: leadsAssignLoading }] = useAssignLeadsMutation();

  let [singleassignLead, { isLoading: singleleadAssignLoading }] = useSingleassignLeadMutation();

  let [Projectassign, { isLoading: projectassignLoading }] = useProjectassignMutation();


  let staffId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      staffId = decryptData(storedStaffId);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  const { data: hierarchyStaff } = useGetSingleHierarchyQuery({ staffId });
  const { data: staff } = useGetActiveStaffQuery();

  const staffOptions = useMemo(() => {
    let options = [];
    hierarchyStaff?.map((staff) =>
      options.push({
        id: staff?._id,
        label: staff?.firstName + " " + staff?.lastName,
      })
    );

    return options;
  }, [hierarchyStaff]);

  const allStaffOptions = useMemo(() => {
    let options = [];
    staff?.map((staff) =>
      options.push({
        id: staff?._id,
        label: staff?.firstName + " " + staff?.lastName,
      })
    );

    return options;
  }, [staff]);

  const [trigger, { data: inventory }] = useLazyGetInventoryByProjectIdQuery();

  useEffect(() => {
    if (singleProject) {
      setloading(false);
    }
  }, [singleProject]);

  useEffect(() => {
    if (task?.DProjectID) {
      setSelectedProject(task.DProjectID);
    }
  }, [task]);

  useEffect(() => {
    if (task.DProjectID || task.DTprojectBlockName) {
      let project = task.DProjectID;
      let block = task.DTprojectBlockName;
      trigger({ project, block });
    }
  }, [task.DProjectID, task.DTprojectBlockName, trigger]);

  let inventoryData = [];
  inventory?.forEach((inven) => {
    if (inven.status === "Available") {
      inventoryData.push({
        unitNo: inven.unitNo,
        id: inven._id,
      });
    }
  });

  useEffect(() => {
    if (task.totalAmount && task.currentSubTypeTask) {
      let calculatedAmount = 0;

      switch (task.currentSubTypeTask) {
        case 'TP':
          calculatedAmount = task.totalAmount * 0.1;
          break;
        case 'PDP':
          calculatedAmount = task.totalAmount * 0.25;
          break;
        case 'DP':
          calculatedAmount = task.totalAmount * 0.25;
          break;
        default:
          calculatedAmount = 0;
      }

      const roundedAmount = parseFloat(calculatedAmount.toFixed(2));

      settask((prevTask) => ({
        ...prevTask,
        ammount: roundedAmount,
      }));
    }
  }, [task.totalAmount, task.currentSubTypeTask]);


  let handleChange = (e, closed) => {
    let { name, value } = e.target;

    if (name === "nextTaskType") {
      setdoNothing(value === "doNothing");
    }

    if (name === "paymentMode" && value !== "bank") {
      settask({ ...task, [name]: value, bankName: "" });
    } else if (closed === "closed") {
      settask({
        ...task, nextTaskType:
          "doNothing", [name]: value
      });

    }
    else {
      settask({
        ...task, nextTaskType:
          task.nextTaskType, [name]: value
      });
    }

  };
  const handleFileChange = (e) => {
    const { name } = e.target;
    settask((prevstate) => ({
      ...prevstate,
      [name]: e.target.files[0],
    }));
    e.target.value = '';
  };

  const handleType = (e) => {
    const { value } = e.target;
    if (value === "Call") {
      setsubType([
        "SMS",
        "Call connected",
        "Call Not Connected",
        "Whatsapp",
        "Followed Up",
      ]);
      setclosedLost(false);
      setdoNothing(false);

    } else if (value === "Meeting") {
      setsubType([
        "Vedio Meeting",
        "Head Office Meeting",
        "Outdoor",
        "Site",
        "Walk In",
      ]);
      setdoNothing(false);

      setclosedLost(false);
    } else if (value === "Sales") {
      let filteredSubType = ["TP", "PDP", "DP", "closed-won"];

      if (task?.leadStatus === "TP") {
        filteredSubType = filteredSubType.filter((type) => type !== "TP");
      } else if (task?.leadStatus === "PDP") {
        filteredSubType = filteredSubType.filter(
          (type) => type !== "TP"
        );
      } else if (task?.leadStatus === "DP") {
        filteredSubType = filteredSubType.filter(
          (type) => type !== "TP" && type !== "PDP" && type !== "DP"
        );
      }
      setsubType(filteredSubType);
      setclosedLost(false);
      setdoNothing(false);

    } else if (value === "closed-lost") {
      settask((prevTask) => ({
        ...prevTask,
        nextTaskType: "doNothing",
      }));
      setsubType(["Nothing"]);
      setdoNothing(true);
      setclosedLost(true);
    }
    handleChange(e, value === "closed-lost" ? "closed" : null);
  };
  const handleSubtype = (e) => {
    settokenDownPayment(false);
    if (
      e.target.value === "TP" ||
      e.target.value === "DP" ||
      e.target.value === "PDP"
    ) {
      settokenDownPayment(true);
    }
    handleChange(e);
  };

  const handleLeadShare = () => {
    let body =
    {
      leadID: leadId,
      sharingEmployee: leadShareData.sharingEmployee.id,
      percentage: leadShareData.percentage
    }

    shareLead(body).unwrap()
      .then((res) => {
        toast.success("lead Shared successfully!")
        setleadSharePopUp(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error?.message || "Error sharing Lead")
      })
      .finally(() => {
        setleadShareData({
          sharingEmployee: { label: "", id: "" },
          percentage: ""
        })
      })
  }


  // useEffect(() => {
  //   setupSocket();
  // }, []);

  const handleSingleLeadassign = () => {

    if (!Singleleadassign.assignEmployee || !Singleleadassign.assignEmployee.id) {
      toast.error("Please select an employee before assigning the lead.");
      return;

    }
    let body =
    {
      leadId: leadId,
      employeeId: Singleleadassign.assignEmployee.id,
    }

    let data = {
      empIds: Singleleadassign.assignEmployee.id,
      leadId: leadIdSm,
    }

    singleassignLead(body).unwrap()
      .then((res) => {
        toast.success("lead Assign successfully!")
        assignLeadNotification(data);
        unSubLeadAssigned();
        setsingleAssignpopup(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error?.message || "Error assign Lead")
      })
      .finally(() => {
        setSingleleadassign({
          assignEmployee: { label: "", id: "" },
        })
      })
  }
  const handleChangeproj = () => {
    if (!projectassign || !projectassign.value) {
      toast.error("Please select a project before changing.");
      return;
    }

    Projectassign({ leadId: leadId, projectId: projectassign.value })
      .unwrap()
      .then((res) => {
        toast.success("Project changed successfully!");
        setprojectpopup(false);
        setprojectassign(null);
      })
      .catch((err) => {
        console.error("Error changing project:", err);
        toast.error("Error changing project");
      });
  };

  const handleMultiLeadAssign = () => {
    if (leadSharedData.assignEmployee.length === 0 || multileadId.length === 0) {
      toast.error("Please select at least one lead");
      return;
    }
    const leadAssignmentData = {
      leadIds: multileadId,
      employeeIds: leadSharedData.assignEmployee.map(emp => emp.id),
    };


    let data = {
      empIds: leadSharedData.assignEmployee.map(emp => emp.id),
      leadId: leads?.leads?.filter((lead) => multileadId.includes(lead._id))
        .map((lead) => lead.leadID)
    }

    assignLeads(leadAssignmentData)
      .unwrap()
      .then((res) => {
        toast.success("Leads assigned successfully!");
        assignLeadNotification(data);
        unSubLeadAssigned();
        setleadSharedData({ assignEmployee: [] });
        setmultileadId([]);
        setleadsSharedPopUp(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error?.message || "Error assigning leads");
      });
  };
  const handleSave = () => {
    var formdata = new FormData();

    const completedDate = moment(task.completedDate).utc().format('YYYY-MM-DDTHH:mm:ss');

    formdata.append("currentTaskType", task.currentTaskType);
    formdata.append("currentSubTypeTask", task.currentSubTypeTask);
    formdata.append("completedDate", completedDate);
    formdata.append("reason", task.reason);
    formdata.append("comment", task.comment);
    formdata.append("nextTaskType", task.nextTaskType);
    formdata.append("deadline", task.deadline);
    formdata.append("attachment", task.attachment);
    formdata.append("idCardFrontPicture", task.cnicfront);
    formdata.append("idCardBackPicture", task.cnicback);
    formdata.append("cnic", task.cnic);
    formdata.append("address", task.address);
    formdata.append("personalPicture", task.personalimage);
    formdata.append("country", task.nationality);
    formdata.append("phoneNo", task.phoneNo);
    formdata.append("developerName", task.developername);
    formdata.append("projectID", task.DProjectID);
    formdata.append("DTprojectBlockName", task.DTprojectBlockName);
    formdata.append("unitNumber", task.invenID);
    formdata.append("amount", task.ammount);
    formdata.append("totalAmount", task.totalAmount);
    formdata.append("paymentMode", task.paymentMode);
    formdata.append("paymentType", task.currentSubTypeTask);
    formdata.append("bankName", task.bankName);
    formdata.append("transactionId", task.transactionNo);
    // formdata.append("depositeDate", task.depositeDate);
    formdata.append("status", task.status);
    formdata.append("paymentproof", task.approvedPayment);
    formdata.append("clientID", task.clientId)
    let id = task.leadId;
    addTask({ formdata, id })
      .unwrap()
      .then((res) => {
        toast.success("task created successfully");
        settask({
          currentTaskType: "",
          currentSubTypeTask: "",
          completedDate: defaultDate,
          reason: "",
          comment: "",
          nextTaskType: "",
          deadline: "",
          DProjectID: "",
          DTprojectBlockName: "",
          invenID: "",
          address: "",
          nationality: "",
          cnic: "",
          developername: "",
          ammount: "",
          paymentMode: "",
          bankName: "",
          transactionNo: "",
          // depositeDate: "",
          status: "",
          attachment: "",
          cnicback: "",
          cnicfront: "",
          leadStatus: "",
          approvedPayment: "",
          leadId: task.leadId,
        });
        setpopUp(false);
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message);
      });
  };

  const [favouriteLoading, setfavouriteLoading] = useState(false);

  // const { data: leads, isFetching } = useGetAllLeadsQuery();

  const [addFavourite] = useAddFavouriteMutation();

  const handleAddFavourite = (id) => {
    setfavouriteLoading(true);
    const body = {
      LeadID: id,
    };
    addFavourite(body)
      .unwrap()
      .then((res) => {
        toast.success(res?.message || "Favourite updated");
        setfavouriteLoading(false);
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message || error?.data?.message || "Failed to update favourite");
        setfavouriteLoading(false);
      });
  };

  useEffect(() => {
    if (taskPopUp || popUp || feedbackPopup || numberPopUp
      || projectpopup || singleAssignpopup || leadsSharedPopUp || leadSharePopUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [taskPopUp, popUp, feedbackPopup, numberPopUp, projectpopup,
    singleAssignpopup, leadsSharedPopUp, leadSharePopUp]);

  const columns = [
    {
      field: "client",
      headerName: "Client",
      width: 150,
      renderCell: (params) => {
        const canManageFavourite = !!params.row?.canManageFavourite;
        return (
          <Client>
            <Tooltip title={params.row.client}>
              <div>{params.row.client} </div>
            </Tooltip>
            <div>
              {canManageFavourite && (
                params.row.favourite ? (
                  <StarIcon
                    sx={{
                      color: `${colors.starYellow}`,
                      fontSize: `small`,
                      cursor: `pointer`,
                    }}
                    onClick={() => handleAddFavourite(params.row.id)}
                  />
                ) : (
                  <StarBorderIcon
                    sx={{
                      color: `${colors.starYellow}`,
                      fontSize: `small`,
                      cursor: `pointer`,
                    }}
                    onClick={() => handleAddFavourite(params.row.id)}
                  />
                )
              )}
              <span><span>Lead

                {params.row.isNew ? (<span style={{ backgroundColor: '#249393', color: 'white', fontSize: '10px', padding: '0 2px', marginLeft: '5px', borderRadius: '3px' }}>New</span>) : (<span></span>)}
              </span>
              </span>
            </div>
          </Client>
        );
      },
    },
    {
      field: "leadId",
      headerName: "Lead ID",
      width: 150,
      renderCell: (params) => {
        return params.row.classification === "veryHot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryHot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "hot" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.hot}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "moderate" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.moderate}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : params.row.classification === "cold" ? (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.cold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        ) : (
          <Id>
            <div>
              <DeviceThermostatIcon
                sx={{
                  color: `${colors.veryCold}`,
                }}
              />
              {params.row.leadId}
            </div>
          </Id>
        );
      },
    },
    {
      field: "source",
      headerName: "Source",
      width: 150,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
      valueGetter: (params) =>
        params.row.phone?.length > 0 ? params.row?.phone[0]?.phoneNo : "",
      renderCell: (params) => {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.phone?.length > 1 ? (
              <button
                onClick={() => {
                  setphoneData(params.row.phone);
                  setnumberPopUp(true);
                }}
                style={{
                  width: "100%",
                  backgroundColor: `${colors.brown}`,
                  color: `${colors.white}`,
                  padding: "0.5em 0em",
                  cursor: "pointer",
                  borderRadius: "5px",
                  border: `1px solid ${colors.inputBorderWhite}`,
                }}
              >
                {params.row?.phone[0]?.phoneNo}
              </button>
            ) : (
              <a href={`tel:+${params.row?.phone[0]?.phoneNo}`}>{params.row?.phone[0]?.phoneNo}</a>
            )}
          </div>
        );
      },
    },
    {
      field: "feedback",
      headerName: "Feedback",
      width: 110,
      renderCell: (params) => {
        return (
          <>
            {
              params.row?.feedback?.length > 0 ?
                <Feedback>
                  <button onClick={() => {
                    setfeedbackPopup(true)
                    setfeedbackData(params.row.feedback)
                  }}>View Feedback</button>
                </Feedback> : "No Feedback"
            }
          </>
        );
      },
    },
    {
      field: "project",
      headerName: "Project",
      width: 110,
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              if (role !== "ts") {
                setprojectpopup(true);
                setleadId(params.row.id);
                setprojectassign({ label: params.row.project });
              } else {
                setprojectpopup(false);
              }
            }}
            style={{
              color: colors.textBlue,
              cursor: 'pointer',
              padding: '4px 8px',
              border: '1px solid transparent',
              borderRadius: '4px',
            }}
          >
            {params.row.project}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 280,
      sortable: false,
      filterable: false,
      hideable: false,
      flex: 0,
      renderCell: (params) => {
        const role = decryptData(localStorage.getItem("role"))
        const whatsappLink = `https://wa.me/${params.row.cellNo}`
        const canAddTask = Boolean(params.row?.canManageFavourite);

        return (
          <Action>
            {canAddTask && (
              <div
                className="no-border-icon"
                onClick={() => {
                  settask({
                    ...task,
                    leadId: params.row.id,
                    clientId: params.row.clientId,
                    clientname: params.row.client,
                    phoneNo: params.row.cellNo,
                    projectName: params.row.project,
                    DProjectID: params.row.projectId,
                    leadStatus: params.row.leadstatus,
                  })
                  setpopUp(true)
                }}
              >
                <img src="/assets/icons/plus.png" alt="plus" />
              </div>
            )}

            <Tooltip title="View Tasks">
              <RemoveRedEyeIcon
                style={{ color: `${colors.brown}`, cursor: "pointer", fontSize: "1.5rem" }}
                onClick={() => {
                  setTaskPopUp(true)
                  setleadId(params.row.id)
                  setLeadNumber(params.row.leadId)
                  setClientPhone(params.row.cellNo || "")
                }}
              />
            </Tooltip>

            <>
              <ArrowCircleRightOutlinedIcon
                style={{ color: "#1194D1", cursor: "pointer" }}
                onClick={() => {
                  setsingleAssignpopup(true)
                  setleadId(params.row.id)
                  setleadIdSm(params.row.leadId)
                }}
              />
              <ShareIcon
                style={{ color: "#EC2643", cursor: "pointer" }}
                onClick={() => {
                  setleadSharePopUp(true)
                  setleadId(params.row.id)
                }}
              />
            </>
            {role !== "ts" && canAddTask && (
              <CMPIconWrapper
                className="no-border-icon"
              onClick={() => {
                  setSelectedLeadForCMP(params.row);
                  setCmpModalOpen(true);
                }}
              >
                <Tooltip title="Add to CMP">
                  <AccountTreeIcon style={{ color: "#9C27B0", cursor: "pointer" }} />
                </Tooltip>
              </CMPIconWrapper>
            )}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
            >
              <WhatsAppIcon style={{ color: "green", cursor: "pointer" }} />
            </a>
          </Action>
        )
      },
    }

  ];
  let rows = [];

  leads?.leads?.forEach((lead) => {
    const leadHolderId = lead?.employeeID?._id?.toString?.() || "";
    const canManageFavourite = leadHolderId && staffId
      ? leadHolderId === staffId.toString()
      : false;

    rows.push({
      client: lead?.clientID?.fullName,
      isNew: lead?.isNew,
      allocatedto: lead?.employeeID?.firstName,
      leadId: lead?.leadID,
      source: lead?.leadOpportunity?.source,
      project: lead?.leadOpportunity?.project?.projectName,
      projectId: lead?.leadOpportunity?.project?._id,
      classification: lead?.leadOpportunity?.classification,
      favourite: lead?.favourite,
      id: lead?._id,
      leadstatus: lead?.leadStatus,
      clientId: lead.clientID?._id,
      cellNo: lead?.clientID?.cellNo[0]?.phoneNo,
      mail: lead?.clientID?.email,
      phone: lead?.clientID?.cellNo,
      feedback: lead?.feedback,
      badge: !lead?.taskExists,
      canManageFavourite,
    });
  });

  const exportCSV = () => {
    const headers = [
      "Client",
      "Lead ID",
      "Source",
      "Phone",
      "Project"
    ];
    const leadsData = leads?.leads.map(lead => [
      lead.clientID?.fullName,
      lead?.leadID,
      lead?.leadOpportunity?.source,
      lead?.clientID?.cellNo[0]?.phoneNo,
      lead?.leadOpportunity?.project?.projectName
    ]);
    const csvContent = [
      headers.join(","),
      ...leadsData.map(lead => lead.join(","))
    ].join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "Totalleads.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Main>
      <LeadsSection>
        <div>
          <div className="lead-count">
            Total Leads: <span>{leads?.totalLeads || 0}</span>
          </div>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleCheckboxChange}
                sx={{
                  color: colors.brown,
                  '&.Mui-checked': {
                    color: colors.brown,
                  },
                }}
              />
            }
            label={
              <div className="new-leads-indicator">
                <span>Assigned New Leads</span>
                {leads?.hasNewLead && <div className="blink-dot"></div>}
              </div>
            }
          />
        </div>
        <div>
          {role === "ceo" || role === "admin" || role === "account" || role === "bdm" ? (
            <StyledButton
              onClick={() => setleadsSharedPopUp(true)}
              disabled={multileadId.length === 0}
              isDisabled={multileadId.length === 0}
            >
              Assign Leads
            </StyledButton>
          ) : null}
          {role === "ceo" || role === "admin" || role === "account" ? (
            <Csvbutton onClick={exportCSV}>
              <FileDownloadIcon />
              Export
            </Csvbutton>
          ) : null}
        </div>
      </LeadsSection>
      <Table>
        {rows.length > 0 ? (
          <DataGrid
            key={`${currentPage}-${pageSize}`}
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            page={currentPage - 1}
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              // Reset to page 1 when page size changes to show correct pagination
              setPage(1);
            }}
            onPageChange={(newPage) => setPage(newPage + 1)}
            rowsPerPageOptions={[50, 20, 100]}
            checkboxSelection
            onSelectionModelChange={(LeadIDs) => {
              setmultileadId(LeadIDs);
            }}
            pagination
            paginationMode="server"
            loading={isFetching}
            loadingOverlay={isFetching ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '200px',
                gap: '1.5rem',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%)',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{
                  position: 'relative',
                  width: '50px',
                  height: '50px'
                }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    border: '4px solid rgba(36, 147, 147, 0.1)',
                    borderTop: '4px solid #249393',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    width: '34px',
                    height: '34px',
                    border: '2px solid rgba(36, 147, 147, 0.2)',
                    borderTop: '2px solid #1a6b6b',
                    borderRadius: '50%',
                    animation: 'spin 1.5s linear infinite reverse'
                  }} />
                </div>
                <div style={{
                  textAlign: 'center',
                  color: '#249393',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    {isFetching ? 'Searching leads...' : 'Loading leads...'}
                  </div>
                  <div style={{
                    fontSize: '0.85rem',
                    color: '#64748b',
                    fontWeight: '400'
                  }}>
                    Please wait while we fetch your data
                  </div>
                </div>
              </div>
            ) : undefined}
            rowCount={leads?.totalLeads || 0}
            autoHeight
            sx={{
              border: "1px solid #e0e0e0",
              width: '100%',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #f0f0f0',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #e0e0e0',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f8f9fa',
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowX: 'auto !important',
              },
              '& .MuiDataGrid-main': {
                overflowX: 'auto !important',
              },
              '& .MuiDataGrid-root': {
                overflowX: 'auto !important',
              },
            }}
          />
        ) : (
          <EmptyState>
            <div className="empty-icon">📊</div>
            <h3>No Leads Found</h3>
            <p>
              {isFetching
                ? "Loading leads..."
                : "No leads match your current search criteria. Try adjusting your filters or search again."
              }
            </p>
          </EmptyState>
        )}
        {favouriteLoading ? <Loader /> : null}
      </Table>
      {feedbackPopup && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Cross onClick={() => setfeedbackPopup(!feedbackPopup)} style={{ height: "3%" }}>
              <img src="/assets/icons/cross.png" alt="cross" />
            </Cross>
            <PopUpSection style={{ height: "90%" }}>
              <FeedbackTable feedback={feedbackData} />
            </PopUpSection>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}

      {popUp && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Cross
              onClick={() => {
                settask({
                  currentTaskType: "",
                  currentSubTypeTask: "",
                  completedDate: defaultDate,
                  subType: "",
                  reason: "",
                  comment: "",
                  nextTaskType: "",
                  developername: "",
                  deadline: "",
                  DProjectID: "",
                  cnic: "",
                  totalAmount: 0,
                  nationality: "",
                  address: "",
                  cnicfront: "",
                  cnicback: "",
                  personalimage: "",
                  DTprojectBlockName: "",
                  invenID: "",
                  ammount: 0,
                  paymentMode: "",
                  bankName: "",
                  transactionNo: 0,
                  leadStatus: "",
                  status: "",
                  attachment: "",
                  approvedPayment: "",
                  leadId: task.leadId,
                });
                setpopUp(false);
              }}
            >
              <img src="/assets/icons/cross.png" alt="cross" />
            </Cross>
            <PopUpSection>
              <Section>
                <Task>
                  <Heading>Current Task</Heading>
                  <InputPart>
                    <InputFeild>
                      <h3>
                        Type:<b style={{ color: "red" }}>*</b>
                      </h3>
                      <div>
                        <select
                          name="currentTaskType"
                          id="currentTaskType"
                          value={task.currentTaskType}
                          onChange={handleType}
                        >
                          {role === "ts" ? (
                            <>
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Call">Call</option>
                            </>
                          ) : (
                            <>
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="Call">Call</option>
                              <option value="Meeting">Meeting</option>
                              <option value="Sales">Sales</option>
                              <option value="closed-lost">Closed (Lost)</option>
                            </>
                          )}
                        </select>
                      </div>
                    </InputFeild>
                    <InputFeild>
                      <h3>Sub-Type:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <select
                          name="currentSubTypeTask"
                          id="currentSubTypeTask"
                          value={task.currentSubTypeTask}
                          onChange={handleSubtype}
                        >
                          <option value=""  >Select</option>
                          {subType?.map((ls) => (
                            <option value={ls} key={ls}>
                              {ls}
                            </option>
                          ))}
                        </select>
                      </div>
                    </InputFeild>
                    <InputFeild>
                      <h3>Completed Date:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <input
                          type="datetime-local"
                          name="completedDate"
                          id="completedDate"
                          value={task.completedDate || defaultDate}
                          onChange={handleChange}
                          min={newMinDate}
                          max={defaultDate}
                        />
                      </div>
                    </InputFeild>
                    {closedLost ? (
                      <InputFeild>
                        <h3>Reason:<b style={{ color: "red" }}>*</b></h3>
                        <input
                          type="text"
                          name="reason"
                          id="reason"
                          placeholder="Type Here..."
                          value={task.reason}
                          onChange={handleChange}
                        />
                      </InputFeild>
                    ) : null}
                    {tokenDownPayment === false ? (
                      <>
                        <InputFeild>
                          <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                          <textarea
                            name="comment"
                            id="comment"
                            placeholder="type here..."
                            value={task.comment}
                            onChange={handleChange}
                          ></textarea>
                        </InputFeild>
                        {
                          task.currentTaskType === 'Meeting' || task.currentTaskType === "Sales" || task.currentSubTypeTask === "Whatsapp" ?
                            <InputFeild>
                              <h3>Attachment:<b style={{ color: "red" }}>*</b></h3>
                              <span>
                                <p>upload file here</p>
                                <label htmlFor="attachment">
                                  <AttachFileIcon /> Upload
                                </label>
                                {task.attachment && (
                                  <UploadedFile
                                    src={URL.createObjectURL(task.attachment)}
                                    alt="uploaded file"
                                  />
                                )}
                              </span>
                              <input
                                type="file"
                                name="attachment"
                                id="attachment"
                                onChange={handleFileChange}
                              />
                            </InputFeild> : null}
                      </>
                    ) : null}
                    {tokenDownPayment ? (
                      <>
                        {/* <InputFeild>
                        <Headinginfo>Project Details</Headinginfo>
                      </InputFeild> */}

                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <>
                            <Heading>Project Details</Heading>
                            <InputFeild>
                              <h3>
                                Project:<b style={{ color: "red" }}>*</b>
                              </h3>
                              <div>
                                <select
                                  name="DProjectID"
                                  id="DProjectID"
                                  disabled
                                  value={selectedProject}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedProject(value);
                                    settask((prevTask) => ({
                                      ...prevTask,
                                      DProjectID: value,
                                    }));
                                  }}
                                >
                                  <option value="">Select Project</option>
                                  {project?.map((pro) => (
                                    <option key={pro._id} value={pro._id}>
                                      {pro.projectName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </InputFeild>
                          </>
                        )}

                        {loading ? (
                          <TaskLoader>
                            <Puff
                              height="40"
                              width="40"
                              radius={1}
                              color={colors.brown}
                              ariaLabel="puff-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              visible={true}
                            />
                          </TaskLoader>
                        ) : null}
                        {singleProject?.projectBlock?.length > 0 ? (
                          <InputFeild>
                            <h3>Project Block:</h3>
                            <div>
                              <select
                                name="DTprojectBlockName"
                                id="DTprojectBlockName"
                                onChange={handleChange}
                              >
                                <option value="">select</option>
                                {singleProject?.projectBlock?.map((pro) => (
                                  <option value={pro.blockName}>
                                    {pro.blockName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </InputFeild>
                        ) : null}
                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <InputFeild>
                            <h3>Unit: <b style={{ color: "red" }}>*</b></h3>
                            <div>
                              <input
                                type="text"
                                name="invenID"
                                id="invenID"
                                value={task.invenID}
                                onChange={handleChange}
                              />
                            </div>
                          </InputFeild>
                        )}
                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <InputFeild>
                            <h3>Developer Name:<b style={{ color: "red" }}>*</b></h3>
                            <div>
                              <input
                                type="text"
                                name="developername"
                                id="developername"
                                value={task.developername}
                                onChange={handleChange}
                              />
                            </div>
                          </InputFeild>
                        )}
                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <InputFeild>
                            <h3>Total Amount:<b style={{ color: "red" }}>*</b></h3>
                            <div>
                              <input
                                type="number"
                                name="totalAmount"
                                id="totalAmount"
                                value={task.totalAmount}
                                onChange={handleChange}
                              />
                            </div>
                          </InputFeild>
                        )}
                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <>
                            <Heading>Client Details</Heading>
                            <InputFeild>
                              <h3>
                                Client Name: <b style={{ color: "red" }}>*</b>
                              </h3>
                              <input
                                type="text"
                                name="clientname"
                                id="clientname"
                                disabled
                                value={task.clientname || ''}
                                onChange={handleChange}
                              />
                            </InputFeild>
                            <InputFeild>
                              <h3>
                                Phone: <b style={{ color: "red" }}>*</b>
                              </h3>
                              <input
                                type="number"
                                name="phone"
                                id="phone"
                                disabled
                                value={task.phoneNo}
                                onChange={handleChange}
                              />
                            </InputFeild>
                            <InputFeild>
                              <h3>
                                CNIC: <b style={{ color: "red" }}>*</b>
                              </h3>
                              <input
                                type="number"
                                name="cnic"
                                id="cnic"
                                value={task.cnic}
                                onChange={handleChange}
                              />
                            </InputFeild>
                            <InputFeild>
                              <h3>
                                Nationality: <b style={{ color: "red" }}>*</b>
                              </h3>
                              <input
                                type="text"
                                name="nationality"
                                id="nationality"
                                value={task.nationality}
                                onChange={handleChange}
                              />
                            </InputFeild>
                            <InputFeild>
                              <h3>
                                Address: <b style={{ color: "red" }}>*</b>
                              </h3>
                              <textarea
                                name="address"
                                id="address"
                                placeholder="type here..."
                                value={task.address}
                                onChange={handleChange}
                              ></textarea>
                            </InputFeild>
                          </>
                        )}

                        <Heading>Add Payment</Heading>
                        <InputFeild>
                          <h3>Payment Mode: <b style={{ color: "red" }}>*</b></h3>
                          <div>
                            <select
                              name="paymentMode"
                              id="paymentMode"
                              onChange={handleChange}
                              value={task.paymentMode}
                            >
                              <option value="">Select</option>
                              <option value="online">Online</option>
                              <option value="cheque">Cheque</option>
                              <option value="cash">Cash</option>
                              <option value="bank">Bank Transfer</option>
                            </select>
                          </div>
                        </InputFeild>
                        {task.paymentMode === "bank" && (
                          <BankInputFeild>
                            <h3>
                              Bank Name: <b style={{ color: "red" }}>*</b>
                            </h3>
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={Banks}
                              value={task.bankName}
                              onChange={(event, newValue) =>
                                settask({ ...task, bankName: newValue })
                              }
                              sx={{
                                width: "100%",
                                border: `1px solid ${colors.inputBorderWhite}`,
                                borderRadius: "5px",
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{ backgroundColor: `${colors.inputWhite}` }}
                                />
                              )}
                            />
                          </BankInputFeild>
                        )}
                        <InputFeild>
                          <h3>Amount:<b style={{ color: "red" }}>*</b></h3>
                          <input
                            type="number"
                            name="ammount"
                            id="ammount"
                            value={task.ammount}
                            onChange={handleChange}
                          />
                        </InputFeild>
                        <InputFeild>
                          <h3>Transaction No:<b style={{ color: "red" }}>*</b></h3>
                          <input
                            type="number"
                            name="transactionNo"
                            id="transactionNo"
                            value={task.transactionNo}
                            onChange={handleChange}
                          />
                        </InputFeild>

                        {/* <InputFeild>
                        <h3>Deposite Date:<b style={{ color: "red" }}>*</b></h3>
                        <div>
                          <input
                            type="date"
                            name="depositeDate"
                            id="depositeDate"
                            value={task.depositeDate}
                            onChange={handleChange}
                          />
                        </div>
                      </InputFeild> */}
                        {task.currentSubTypeTask === "DP" && (
                          <InputFeild>
                            <h3>Personal Image:<b style={{ color: "red" }}>*</b></h3>
                            <span>
                              <p>upload file here</p>
                              <label htmlFor="personalimage">
                                <AttachFileIcon /> Upload
                              </label>
                              {task.personalimage && (
                                <UploadedFile
                                  src={URL.createObjectURL(task.personalimage)}
                                  alt="uploaded file"
                                />
                              )}
                            </span>
                            <input
                              type="file"
                              name="personalimage"
                              id="personalimage"
                              onChange={handleFileChange}
                            />
                          </InputFeild>
                        )}
                        {task.leadStatus !== "TP" && task.leadStatus !== "DP" && task.leadStatus !== "PDP" && (
                          <>
                            <InputFeild>
                              <h3>CNIC Front:<b style={{ color: "red" }}>*</b></h3>
                              <span>
                                <p>upload file here</p>
                                <label htmlFor="cnicfront">
                                  <AttachFileIcon /> Upload
                                </label>
                                {task.cnicfront && (
                                  <UploadedFile
                                    src={URL.createObjectURL(task.cnicfront)}
                                    alt="uploaded file"
                                  />
                                )}
                              </span>
                              <input
                                type="file"
                                name="cnicfront"
                                id="cnicfront"
                                onChange={handleFileChange}
                              />
                            </InputFeild>
                            <InputFeild>
                              <h3>CNIC Back:<b style={{ color: "red" }}>*</b></h3>
                              <span>
                                <p>upload file here</p>
                                <label htmlFor="cnicback">
                                  <AttachFileIcon /> Upload
                                </label>
                                {task.cnicback && (
                                  <UploadedFile
                                    src={URL.createObjectURL(task.cnicback)}
                                    alt="uploaded file"
                                  />
                                )}
                              </span>
                              <input
                                type="file"
                                name="cnicback"
                                id="cnicback"
                                onChange={handleFileChange}
                              />
                            </InputFeild>
                          </>
                        )}
                        <InputFeild>
                          <h3>Attach Payment Proof:<b style={{ color: "red" }}>*</b></h3>
                          <span>
                            <p>upload file here</p>
                            <label htmlFor="approvedPayment">
                              <AttachFileIcon /> Upload
                            </label>
                            {task.approvedPayment && (
                              <UploadedFile
                                src={URL.createObjectURL(task.approvedPayment)}
                                alt="uploaded file"
                              />
                            )}
                          </span>
                          <input
                            type="file"
                            name="approvedPayment"
                            id="approvedPayment"
                            onChange={handleFileChange}
                          />
                          <p>
                            Note: Invalid payment proof will result in
                            cancellation of payment and inventory will released
                            immediately.
                          </p>
                        </InputFeild>
                        <InputFeild>
                          <h3>Comment:<b style={{ color: "red" }}>*</b></h3>
                          <textarea
                            name="comment"
                            id="comment"
                            placeholder="type here..."
                            value={task.comment}
                            onChange={handleChange}
                          ></textarea>
                        </InputFeild>
                      </>
                    ) : null}
                  </InputPart>
                </Task>
              </Section>
              <Section>
                <Task style={{ borderRight: "none" }}>
                  <Heading>Next Task</Heading>
                  <InputPart>
                    <InputFeild>
                      <h3>Next Task:<b style={{ color: "red" }}>*</b></h3>
                      <div>
                        <select
                          name="nextTaskType"
                          id="nextTaskType"
                          value={task.nextTaskType || ""}
                          onChange={handleChange}
                        >
                          {role === "ts" ? (
                            <>
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="meetClient">Meet Client</option>
                              <option value="Meeting">Meeting</option>
                              <option value="rescheduleMeeting">Reschedule Meeting</option>
                            </>
                          ) : (
                            <>
                              <option value="" disabled>
                                Select
                              </option>
                              <option value="doNothing">Do Nothing</option>
                              <option value="followUp">Follow Up</option>
                              <option value="contractedClient">Contracted Client</option>
                              <option value="closed-won">Close Won</option>
                              <option value="meetClient">Meet Client</option>
                              <option value="recievePartialDownPayment">Receive Partial Down Payment</option>
                              <option value="recieveCompleteDownPayment">Receive Complete Down Payment</option>
                              <option value="arrangeMeeting">Arrange Meeting</option>
                              <option value="receivetokenPayment">Receive Token Payment</option>
                            </>
                          )}
                        </select>
                      </div>
                    </InputFeild>

                    {doNothing === false ? (
                      <InputFeild>
                        <h3>Deadline:<b style={{ color: "red" }}>*</b></h3>
                        <div>
                          <input
                            type="datetime-local"
                            name="deadline"
                            id="deadline"
                            value={task.deadline}
                            onChange={handleChange}
                            min={new Date().toISOString().slice(0, 16)}
                          />
                        </div>
                      </InputFeild>
                    ) : null}
                  </InputPart>
                </Task>
              </Section>
            </PopUpSection>
            <ButtonPart>
              <button
                className="cancel-btn"
                onClick={() => {
                  settask({
                    currentTaskType: "",
                    currentSubTypeTask: "",
                    completedDate: defaultDate,
                    subType: "",
                    reason: "",
                    comment: "",
                    nextTaskType: "",
                    developername: "",
                    deadline: "",
                    DProjectID: "",
                    cnic: "",
                    nationality: "",
                    address: "",
                    cnicfront: "",
                    cnicback: "",
                    personalimage: "",
                    DTprojectBlockName: "",
                    totalAmount: 0,
                    invenID: "",
                    ammount: 0,
                    paymentMode: "",
                    bankName: "",
                    transactionNo: 0,
                    leadStatus: "",
                    status: "",
                    attachment: "",
                    approvedPayment: "",
                    leadId: task.leadId,
                  });
                  setpopUp(false);
                }}
              >
                Cancel
              </button>
              <button
                className="save-btn"
                style={{
                  opacity: isLoading ? "0.5" : "1",
                }}
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? <>Saving...</> : <>Save</>}
              </button>
            </ButtonPart>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      {taskPopUp && createPortal(
        <PortalPopUpContainer>
          <PopUp>
            <Crosstask
              onClick={() => setTaskPopUp(!taskPopUp)}
            >
              <img src="/assets/icons/cross.png" alt="cross" />
            </Crosstask>
            <PopUpSection className="task-table-section" style={{ height: "calc(100% - 80px)" }}>
              <UnifiedTaskTable leadID={leadId} leadNumber={leadNumber} clientPhone={clientPhone} />
            </PopUpSection>
          </PopUp>
        </PortalPopUpContainer>,
        document.body
      )}
      <PopUpContainer popUp={numberPopUp}>
        <NumberPopUp>
          <Cross
            onClick={() => setnumberPopUp(!numberPopUp)}
            style={{ height: "5%" }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          <NumberPopUpSection style={{ height: "90%", overflowY: "scroll", paddingTop: "1em" }}>

            {phoneData.map((phone) => (
              <div>
                <span>Phone No: </span> <a href={`tel:+${phone.phoneNo}`}>{phone.phoneNo}</a>

              </div>
            ))}
          </NumberPopUpSection>
        </NumberPopUp>
      </PopUpContainer>
      <PopUpContainer popUp={leadSharePopUp}>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <AssignLeadModal key={`share-modal-${Date.now()}`}>
          <Cross
            onClick={() => {
              setleadSharePopUp(!leadSharePopUp);
              setleadShareData({ ...leadShareData, sharingEmployee: null });
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>

          {/* Professional Header */}
          <div style={{
            padding: '2rem 2rem 1rem 2rem',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: '16px 16px 0 0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(236, 38, 67, 0.3)'
              }}>
                <ShareIcon style={{ color: 'white', fontSize: '24px' }} />
              </div>
              <div>
                <h2 style={{
                  margin: 0,
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  letterSpacing: '-0.025em'
                }}>
                  Share Lead
                </h2>
                <p style={{
                  margin: '0.25rem 0 0 0',
                  fontSize: '0.95rem',
                  color: '#6b7280',
                  fontWeight: '500'
                }}>
                  Share this lead with another team member
                </p>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div style={{
            padding: '2rem',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'
          }}>
            {/* Staff Selection */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <label style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Select Staff Member
              </label>
              <Autocomplete
                id="share-staff-autocomplete"
                size="small"
                options={allStaffOptions}
                getOptionLabel={(option) => option.label}
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
                onChange={(e, value) => {
                  setleadShareData({ ...leadShareData, sharingEmployee: value })
                }}
                value={leadShareData.sharingEmployee}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Choose a staff member..."
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#ffffff',
                        border: '2px solid #e5e7eb',
                        '&:hover': {
                          borderColor: '#d1d5db',
                        },
                        '&.Mui-focused': {
                          borderColor: '#EC2643',
                          boxShadow: '0 0 0 3px rgba(236, 38, 67, 0.1)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#6b7280',
                        fontWeight: '500',
                      },
                    }}
                  />
                )}
              />
            </div>

            {/* Percentage Input */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <label style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Share Percentage
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type="number"
                  name="percentage"
                  id="percentage"
                  max={100}
                  min={0}
                  defaultValue={leadShareData.percentage}
                  onBlur={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue === '') {
                      setleadShareData({ ...leadShareData, percentage: '' });
                      return;
                    }
                    const numValue = parseFloat(inputValue);
                    if (!isNaN(numValue)) {
                      const clampedValue = Math.min(100, Math.max(0, numValue));
                      setleadShareData({ ...leadShareData, percentage: clampedValue.toString() });
                      e.target.value = clampedValue.toString();
                    }
                    // Reset styling
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.boxShadow = 'none';
                  }}
                  placeholder="Enter percentage (0-100)"
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    fontSize: '1rem',
                    fontWeight: '500',
                    borderRadius: '12px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: '#ffffff',
                    color: '#374151',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#EC2643';
                    e.target.style.boxShadow = '0 0 0 3px rgba(236, 38, 67, 0.1)';
                  }}
                />
                <span style={{
                  position: 'absolute',
                  right: '16px',
                  top: '50%',
                  color: '#6b7280',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  pointerEvents: 'none'
                }}>
                  %
                </span>
              </div>
            </div>
          </div>

          {/* Footer Section */}
          <div style={{
            padding: '1.5rem 2rem 2rem 2rem',
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa'
          }}>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setleadSharePopUp(!leadSharePopUp);
                  setleadShareData({ ...leadShareData, sharingEmployee: null });
                }}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: '2px solid #d1d5db',
                  background: '#ffffff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#9ca3af';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.color = '#6b7280';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleLeadShare}
                disabled={leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: 'none',
                  background: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? '#d1d5db'
                    : `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`,
                  color: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? '#9ca3af'
                    : '#ffffff',
                  cursor: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? 'not-allowed'
                    : 'pointer',
                  minWidth: '120px',
                  boxShadow: leadShareLoading || !leadShareData.sharingEmployee || !leadShareData.percentage
                    ? 'none'
                    : '0 4px 12px rgba(236, 38, 67, 0.3)',
                  opacity: leadShareLoading ? '0.7' : '1'
                }}
              >
                {leadShareLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid transparent',
                      borderTop: '2px solid currentColor',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Sharing...
                  </div>
                ) : (
                  'Share Lead'
                )}
              </button>
            </div>
          </div>
        </AssignLeadModal>
      </PopUpContainer>

      <PopUpContainer popUp={projectpopup}>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <NumberPopUp style={{ height: "50vh" }}>
          <Cross
            onClick={() => {
              setprojectpopup(false);
              setprojectassign(null);
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>

          <div style={{
            padding: '2rem 2rem 1rem 2rem',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: '16px 16px 0 0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(236, 38, 67, 0.3)'
              }}>
                <SwapHorizIcon style={{ color: 'white', fontSize: '24px' }} />

              </div>
              <div>
                <h2 style={{
                  margin: 0,
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  letterSpacing: '-0.025em'
                }}>
                  Project
                </h2>
                <p style={{
                  margin: '0.25rem 0 0 0',
                  fontSize: '0.95rem',
                  color: '#6b7280',
                  fontWeight: '500'
                }}>
                  Change the project for this lead.
                </p>
              </div>
            </div>
          </div>
          <div style={{
            padding: '2rem',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <label style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem'
              }}>
                Select Project
              </label>
              <Autocomplete
                id="project-autocomplete"
                size="small"
                options={projectOptions}
                getOptionLabel={(option) => option.label}
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
                onChange={(e, value) => {
                  setprojectassign(value);
                }}
                value={projectassign}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Choose a staff member..."
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#ffffff',
                        border: '2px solid #e5e7eb',
                        '&:hover': {
                          borderColor: '#d1d5db',
                        },
                        '&.Mui-focused': {
                          borderColor: '#EC2643',
                          boxShadow: '0 0 0 3px rgba(236, 38, 67, 0.1)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#6b7280',
                        fontWeight: '500',
                      },
                    }}
                  />
                )}
              />
            </div>
          </div>

          {/* Footer Section */}
          <div style={{
            padding: '1.5rem 2rem 2rem 2rem',
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa'
          }}>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setprojectpopup(false);
                  setprojectassign(null);
                }}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: '2px solid #d1d5db',
                  background: '#ffffff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#9ca3af';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.color = '#6b7280';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleChangeproj}
                disabled={projectassignLoading || !projectassign?.value}
                style={{
                  padding: "12px 24px",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  borderRadius: "10px",
                  border: "none",
                  background: projectassign?.value
                    ? `linear-gradient(135deg, #EC2643 0%, #c41e3a 100%)`
                    : "#d1d5db",
                  color: projectassign?.value ? "#ffffff" : "#9ca3af",
                  cursor: projectassignLoading || !projectassign?.value
                    ? "not-allowed"
                    : "pointer",
                  minWidth: "120px",
                  boxShadow: projectassign?.value
                    ? "0 4px 12px rgba(236, 38, 67, 0.3)"
                    : "none",
                  opacity: projectassignLoading ? "0.7" : "1",
                }}
              >
                {projectassignLoading ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        border: "2px solid transparent",
                        borderTop: "2px solid currentColor",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    Changing...
                  </div>
                ) : (
                  "Change"
                )}
              </button>

            </div>
          </div>

        </NumberPopUp>
      </PopUpContainer>

      <PopUpContainer popUp={singleAssignpopup}>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <AssignLeadModal key={`assign-modal-${Date.now()}`}>
          <Cross
            onClick={() => {
              setsingleAssignpopup(!singleAssignpopup);
              setSingleleadassign({ ...Singleleadassign, assignEmployee: null });
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>

          {/* Professional Header */}
          <div style={{
            padding: '2rem 2rem 1rem 2rem',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: '16px 16px 0 0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(36, 147, 147, 0.3)'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <h2 style={{
                  color: '#1a1a1a',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  margin: 0,
                  letterSpacing: '-0.02em'
                }}>
                  Assign Lead
                </h2>
                <p style={{
                  color: '#6b7280',
                  fontSize: '0.9rem',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  Choose the right team member for this lead
                </p>
              </div>
            </div>
          </div>

          {/* Content Area */}
          <div style={{
            padding: '2rem',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'
          }}>
            <div style={{
              background: '#f8f9fa',
              borderRadius: '12px',
              padding: '1.5rem',
              border: '1px solid #e5e7eb'
            }}>
              <label style={{
                display: 'block',
                fontSize: '0.9rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Select Employee
              </label>

              <Autocomplete
                id="assign-employee-select"
                size="medium"
                options={
                  role === "ceo" || role === "admin" || role === "account"
                    ? allStaffOptions
                    : staffOptions
                }
                getOptionLabel={(option) => option.label}
                style={{ width: "100%" }}
                onChange={(e, value) => {
                  setSingleleadassign({ ...Singleleadassign, assignEmployee: value })
                }}
                value={Singleleadassign.assignEmployee}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Type to search employees..."
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        '& fieldset': {
                          borderColor: '#d1d5db',
                          borderWidth: '2px',
                        },
                        '&:hover fieldset': {
                          borderColor: colors.brown,
                          boxShadow: '0 0 0 3px rgba(36, 147, 147, 0.1)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.brown,
                          boxShadow: '0 0 0 3px rgba(36, 147, 147, 0.15)',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '16px 20px',
                        fontSize: '1rem',
                        fontWeight: '500',
                        color: '#1f2937'
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: '#9ca3af',
                        fontWeight: '400'
                      }
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} style={{
                    padding: '12px 20px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    borderBottom: '1px solid #f3f4f6'
                  }}>
                    {option.label}
                  </li>
                )}
              />
            </div>

            {/* Selected Employee Preview */}
            {Singleleadassign.assignEmployee && Singleleadassign.assignEmployee.id && (
              <div style={{
                background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                borderRadius: '12px',
                padding: '1.5rem',
                border: '2px solid #10b981',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#10b981',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '1.1rem'
                }}>
                  {Singleleadassign.assignEmployee.label.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p style={{ margin: 0, fontWeight: '600', color: '#065f46', fontSize: '1rem' }}>
                    {Singleleadassign.assignEmployee.label}
                  </p>
                  <p style={{ margin: 0, color: '#047857', fontSize: '0.85rem' }}>
                    Ready to assign this lead
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Professional Footer */}
          <div style={{
            padding: '1.5rem 2rem 2rem 2rem',
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa'
          }}>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setsingleAssignpopup(!singleAssignpopup);
                  setSingleleadassign({ ...Singleleadassign, assignEmployee: null });
                }}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: '2px solid #d1d5db',
                  background: '#ffffff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#9ca3af';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.color = '#6b7280';
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleSingleLeadassign}
                disabled={singleleadAssignLoading || !Singleleadassign.assignEmployee || !Singleleadassign.assignEmployee.id}
                style={{
                  padding: '12px 32px',
                  fontSize: '0.95rem',
                  fontWeight: '700',
                  borderRadius: '10px',
                  border: 'none',
                  background: Singleleadassign.assignEmployee && Singleleadassign.assignEmployee.id
                    ? `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`
                    : '#d1d5db',
                  color: 'white',
                  cursor: Singleleadassign.assignEmployee && Singleleadassign.assignEmployee.id ? 'pointer' : 'not-allowed',
                  minWidth: '140px',
                  opacity: singleleadAssignLoading ? "0.7" : "1",
                  boxShadow: Singleleadassign.assignEmployee && Singleleadassign.assignEmployee.id
                    ? '0 4px 14px rgba(36, 147, 147, 0.4)'
                    : 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}
              >
                {singleleadAssignLoading ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Assigning...
                  </span>
                ) : (
                  'Assign Lead'
                )}
              </button>
            </div>
          </div>
        </AssignLeadModal>
      </PopUpContainer>

      <PopUpContainer popUp={leadsSharedPopUp}>
        <AssignLeadModal>
          <Cross
            onClick={() => {
              setleadsSharedPopUp(!leadsSharedPopUp);
              setleadSharedData({ ...leadSharedData, assignEmployee: [] });
            }}
          >
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>

          {/* Professional Header */}
          <div style={{
            padding: '2rem 2rem 1rem 2rem',
            borderBottom: '1px solid #f0f0f0',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: '16px 16px 0 0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(36, 147, 147, 0.3)'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <h2 style={{
                  color: '#1a1a1a',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  margin: 0,
                  letterSpacing: '-0.02em'
                }}>
                  Bulk Assign Leads
                </h2>
                <p style={{
                  color: '#6b7280',
                  fontSize: '0.9rem',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  Select multiple team members to assign leads
                </p>
              </div>
            </div>
          </div>

          {/* Content Area */}
          <div style={{
            padding: '2rem',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
            overflowY: 'auto',
            maxHeight: 'calc(100% - 200px)'
          }}>
            <div style={{
              background: '#f8f9fa',
              borderRadius: '12px',
              padding: '1.5rem',
              border: '1px solid #e5e7eb'
            }}>
              <label style={{
                display: 'block',
                fontSize: '0.9rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}>
                Select Team Members
              </label>

              <Autocomplete
                id="bulk-assign-employees"
                multiple
                size="medium"
                options={
                  role === "ceo" || role === "admin" || role === "account"
                    ? allStaffOptions
                    : staffOptions
                }
                getOptionLabel={(option) => option.label}
                style={{ width: "100%" }}
                onChange={(e, value) => {
                  setleadSharedData({ ...leadSharedData, assignEmployee: value });
                }}
                value={leadSharedData.assignEmployee}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select team members..."
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        minHeight: '60px',
                        '& fieldset': {
                          borderColor: '#d1d5db',
                          borderWidth: '2px',
                        },
                        '&:hover fieldset': {
                          borderColor: colors.brown,
                          boxShadow: '0 0 0 3px rgba(36, 147, 147, 0.1)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: colors.brown,
                          boxShadow: '0 0 0 3px rgba(36, 147, 147, 0.15)',
                        },
                      },
                      '& .MuiInputBase-input': {
                        padding: '16px 20px',
                        fontSize: '1rem',
                        fontWeight: '500',
                        color: '#1f2937'
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: '#9ca3af',
                        fontWeight: '400'
                      }
                    }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <div
                      key={option.id}
                      style={{
                        background: `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`,
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        margin: '2px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      <div style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        background: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        fontWeight: '700'
                      }}>
                        {option.label.charAt(0).toUpperCase()}
                      </div>
                      {option.label}
                      <button
                        onClick={() => {
                          const newValue = value.filter((_, i) => i !== index);
                          setleadSharedData({ ...leadSharedData, assignEmployee: newValue });
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'white',
                          cursor: 'pointer',
                          padding: '0',
                          marginLeft: '4px',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))
                }
                renderOption={(props, option) => (
                  <li {...props} style={{
                    padding: '12px 20px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    borderBottom: '1px solid #f3f4f6',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}>
                      {option.label.charAt(0).toUpperCase()}
                    </div>
                    {option.label}
                  </li>
                )}
              />
            </div>

            {/* Selected Employees Preview */}
            {leadSharedData.assignEmployee.length > 0 && (
              <div style={{
                background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                borderRadius: '12px',
                padding: '1.5rem',
                border: '2px solid #10b981'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: '#10b981',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '1.1rem'
                  }}>
                    {leadSharedData.assignEmployee.length}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontWeight: '600', color: '#065f46', fontSize: '1rem' }}>
                      {leadSharedData.assignEmployee.length} Team Member{leadSharedData.assignEmployee.length > 1 ? 's' : ''} Selected
                    </p>
                    <p style={{ margin: 0, color: '#047857', fontSize: '0.85rem' }}>
                      Ready to assign leads to selected team members
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {leadSharedData.assignEmployee.map((employee, index) => (
                    <div key={employee.id} style={{
                      background: '#ffffff',
                      border: '1px solid #d1fae5',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '500',
                      color: '#065f46',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}>
                      <div style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '50%',
                        background: '#10b981',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '0.7rem',
                        fontWeight: '600'
                      }}>
                        {employee.label.charAt(0).toUpperCase()}
                      </div>
                      {employee.label}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Professional Footer */}
          <div style={{
            padding: '1.5rem 2rem 2rem 2rem',
            borderTop: '1px solid #f0f0f0',
            background: '#fafafa',
            flexShrink: 0,
            marginTop: 'auto'
          }}>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setleadsSharedPopUp(!leadsSharedPopUp);
                  setleadSharedData({ ...leadSharedData, assignEmployee: [] });
                }}
                style={{
                  padding: '12px 24px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  border: '2px solid #d1d5db',
                  background: '#ffffff',
                  color: '#6b7280',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#9ca3af';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d1d5db';
                  e.target.style.color = '#6b7280';
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleMultiLeadAssign}
                disabled={leadsAssignLoading || leadSharedData.assignEmployee.length === 0}
                style={{
                  padding: '12px 32px',
                  fontSize: '0.95rem',
                  fontWeight: '700',
                  borderRadius: '10px',
                  border: 'none',
                  background: leadSharedData.assignEmployee.length > 0
                    ? `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`
                    : '#d1d5db',
                  color: 'white',
                  cursor: leadSharedData.assignEmployee.length > 0 ? 'pointer' : 'not-allowed',
                  minWidth: '160px',
                  opacity: leadsAssignLoading ? "0.7" : "1",
                  boxShadow: leadSharedData.assignEmployee.length > 0
                    ? '0 4px 14px rgba(36, 147, 147, 0.4)'
                    : 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}
              >
                {leadsAssignLoading ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Assigning...
                  </span>
                ) : (
                  `Assign to ${leadSharedData.assignEmployee.length} Member${leadSharedData.assignEmployee.length > 1 ? 's' : ''}`
                )}
              </button>
            </div>
          </div>
        </AssignLeadModal>
      </PopUpContainer>

      {cmpModalOpen && selectedLeadForCMP && (
        <AddToCMPModal
          open={cmpModalOpen}
          onClose={() => {
            setCmpModalOpen(false);
            setSelectedLeadForCMP(null);
          }}
          lead={selectedLeadForCMP}
        />
      )}

      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;
const LeadsSection = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  > div {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
  
  .lead-count {
    font-size: 1.1rem;
    color: ${colors.text};
    font-weight: 600;
    
  span {
      color: ${colors.brown};
      font-weight: 700;
      font-size: 1.2rem;
    }
  }
  
  .new-leads-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: ${colors.textMed};
    
    .blink-dot {
      width: 8px;
      height: 8px;
      background-color: ${colors.brown};
      border-radius: 50%;
      animation: blink 1s infinite;
    }
  }
  
  @keyframes blink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0.3; }
  }
`;
const Csvbutton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.textMed};
  background: ${colors.white};
  padding: 12px 16px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  
  &:hover {
    border-color: ${colors.brown};
    color: ${colors.brown};
    background: ${colors.lightWhite};
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.15);
  }
  
  &:active {
  }
`
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: ${colors.white};
  background: ${(props) =>
    props.isDisabled
      ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
      : `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`};
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  font-size: 0.875rem;
  font-weight: 600;
  box-shadow: ${(props) =>
    props.isDisabled
      ? '0 2px 4px rgba(0, 0, 0, 0.1)'
      : '0 4px 12px rgba(36, 147, 147, 0.3)'};
  
  &:hover:not(:disabled) {
    box-shadow: 0 8px 20px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
  
  &:active:not(:disabled) {
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Table = styled.div`
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  overflow-x: auto;
  width: 100%;
  min-height: 400px;
  
  .MuiDataGrid-root {
    border: none !important;
    border-radius: 16px;
    overflow: visible !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    background: ${colors.white};
    transition: all 0.3s ease;
    min-width: fit-content;
    
    &:hover {
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    }
  }
  
  .MuiDataGrid-main {
    border-radius: 16px;
    overflow-x: auto !important;
  }
  
  .MuiDataGrid-virtualScroller {
    overflow-x: auto !important;
  }
  
  .MuiDataGrid-columnHeaders {
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    border-bottom: 3px solid ${colors.inputBorderWhite};
    font-weight: 700;
    color: ${colors.text};
    min-height: 60px !important;
    
    .MuiDataGrid-columnHeaderTitle {
      font-weight: 700;
      font-size: 0.9rem;
      letter-spacing: 0.025em;
    }
  }
  
  .MuiDataGrid-columnHeader {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.text};
    padding: 0 16px;
  }
  
  .MuiDataGrid-row {
    border-bottom: 1px solid ${colors.inputBorderWhite};
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    
    &.Mui-selected {
      background: linear-gradient(135deg, rgba(36, 147, 147, 0.1) 0%, rgba(36, 147, 147, 0.05) 100%) !important;
      border-left: 4px solid ${colors.brown};
    }
    
    &:nth-of-type(even) {
      background: rgba(248, 249, 250, 0.5);
    }
  }
  
  .MuiDataGrid-cell {
    border: none !important;
    font-size: 0.85rem;
    color: ${colors.text};
    padding: 16px;
    display: flex;
    align-items: center;
    
    &:focus {
      outline: none;
    }
  }
  
  .MuiDataGrid-footerContainer {
    border-top: 2px solid ${colors.inputBorderWhite};
    background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
    min-height: 70px;
    padding: 0 24px;
  }
  
  .MuiTablePagination-root {
    color: ${colors.textMed};
    font-weight: 500;
    
    .MuiTablePagination-selectLabel,
    .MuiTablePagination-displayedRows {
      font-weight: 600;
      color: ${colors.text};
    }
    
    .MuiTablePagination-select {
      border-radius: 8px;
      border: 1px solid ${colors.inputBorderWhite};
      padding: 4px 8px;
      
      &:hover {
        border-color: ${colors.brown};
      }
    }
  }
  
  .MuiCheckbox-root {
    color: ${colors.brown} !important;
    padding: 8px;
    
    &.Mui-checked {
      color: ${colors.brown} !important;
    }
    
    &:hover {
      background: rgba(36, 147, 147, 0.1);
      border-radius: 4px;
    }
  }
  
  // Custom scrollbar
  .MuiDataGrid-virtualScroller {
    overflow-x: auto !important;
    overflow-y: auto !important;
    
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: ${colors.lightWhite};
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${colors.inputBorderWhite};
      border-radius: 4px;
      
      &:hover {
        background: ${colors.textMed};
      }
    }
  }
  
  .MuiDataGrid-virtualScrollerContent {
    min-width: 100%;
  }
  
  @media (max-width: 768px) {
    padding: 1rem 2rem 2rem 2rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 50px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.8rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.8rem;
      padding: 0 12px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.8rem;
      padding: 12px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 60px;
      padding: 0 16px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 1rem 1rem 1rem;
    
    .MuiDataGrid-columnHeaders {
      min-height: 45px !important;
      
      .MuiDataGrid-columnHeaderTitle {
        font-size: 0.75rem;
      }
    }
    
    .MuiDataGrid-columnHeader {
      font-size: 0.75rem;
      padding: 0 8px;
    }
    
    .MuiDataGrid-cell {
      font-size: 0.75rem;
      padding: 8px;
    }
    
    .MuiDataGrid-footerContainer {
      min-height: 50px;
      padding: 0 12px;
    }
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
  border-radius: 20px;
  border: 2px dashed ${colors.inputBorderWhite};
  margin: 2rem 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(36, 147, 147, 0.05) 0%, transparent 70%);
    animation: float 6s ease-in-out infinite;
  }
  
  .empty-icon {
    font-size: 5rem;
    margin-bottom: 1.5rem;
    opacity: 0.8;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    animation: bounce 2s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
  
  h3 {
    color: ${colors.text};
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
    position: relative;
    z-index: 1;
    background: linear-gradient(135deg, ${colors.text}, ${colors.brown});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: ${colors.textMed};
    font-size: 1.1rem;
    margin: 0;
    max-width: 450px;
    line-height: 1.6;
    position: relative;
    z-index: 1;
    font-weight: 500;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
  
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-10px); }
    60% { transform: translateY(-5px); }
  }
`;

const Client = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
`;

const Id = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: ${colors.textBlue};
  }
  p {
    color: ${colors.textMed};
  }
`;

const CMPIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  
  &.no-border-icon {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }
`;

const Action = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
  padding: 8px;
  flex-wrap: nowrap;
  min-width: fit-content;
  
  div {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    background: linear-gradient(135deg, ${colors.white} 0%, ${colors.lightWhite} 100%);
    border: 1px solid ${colors.inputBorderWhite};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    
    &:hover {
      background: linear-gradient(135deg, ${colors.lightWhite} 0%, rgba(36, 147, 147, 0.1) 100%);
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-color: ${colors.brown};
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    
    &.no-border-icon {
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;
      
      &:hover {
        background: transparent !important;
        transform: translateY(-2px);
        box-shadow: none !important;
      }
    }
    
    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }
  }
  
  .MuiSvgIcon-root {
    transition: all 0.3s ease;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    
    &:hover {
      transform: scale(1.1);
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }
  }
  
  // WhatsApp icon special styling
  .MuiSvgIcon-root[style*="green"] {
    &:hover {
      color: #25d366 !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(37, 211, 102, 0.3));
    }
  }
  
  // Eye icon special styling
  .MuiSvgIcon-root[style*="brown"] {
    &:hover {
      color: ${colors.brown} !important;
      transform: scale(1.15);
      filter: drop-shadow(0 2px 8px rgba(36, 147, 147, 0.3));
    }
  }
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  isolation: isolate;
`;

const PortalPopUpContainer = styled.div`
  background-color: #0000004d;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  isolation: isolate !important;
  pointer-events: auto !important;
`;

const PopUp = styled.div`
  width: 95vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  overflow: hidden;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  /* Allow tooltips to appear above modal */
  .MuiDataGrid-root {
    z-index: 1 !important;
  }
  
  .MuiDataGrid-columnHeaders {
    z-index: 2 !important;
  }
  
  .MuiDataGrid-menuIcon {
    z-index: 3 !important;
  }
  
  .MuiDataGrid-columnHeaderTitle {
    z-index: 2 !important;
  }
  
  /* Ensure tooltips appear above modal */
  .MuiTooltip-popper {
    z-index: 9999 !important;
  }
`;
const NumberPopUp = styled.div`
  width: 90vw !important;
  max-width: 500px !important;
  height: auto !important;
  min-height: 500px !important;
  max-height: 85vh !important;
  overflow: hidden !important;
  background-color: ${colors.white} !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const AssignLeadModal = styled.div`
  width: 90vw !important;
  max-width: 500px !important;
  height: auto !important;
  min-height: 500px !important;
  max-height: 85vh !important;
  overflow: hidden !important;
  background-color: ${colors.white} !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    border-radius: 16px 16px 0 0;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Cross = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;
const Crosstask = styled.div`
  position: absolute;
  top: 10px;
  right: 2px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff4757;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  
  &:hover {
    background: #ff3742;
    box-shadow: 0 6px 16px rgba(255, 71, 87, 0.4);
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
`;

const PopUpSection = styled.div`
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  flex: 1;
  overflow-y: auto;
  padding: 0;
  
  &.task-table-section {
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
  }
`;
const NumberPopUpSection = styled(PopUpSection)`
  flex-direction: column;
  margin: 1em;
  justify-content: center;
  line-height: 3em;
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-right: 1px solid #e0e0e0;
  height: 100%;
  
  &:last-child {
    border-right: none;
  }
`;

const Task = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1.5rem;
`;

const Heading = styled.div`
  width: 100%;
  text-align: left;
  padding: 0 0 1rem 0;
  color: ${colors.textBlue};
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem;
`;

const InputPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${colors.text};
    margin: 0 0 0.5rem 0;
  }
`;

const InputFeild = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }
  p {
    color: ${colors.veryHot};
    margin-top: 0.5em;
  }
  div {
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    width: 100%;
    background-color: #f8f9fa;
    
    &:focus-within {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    select,
    input[type="date"] {
      background-color: transparent;
      width: 100%;
      padding: 12px 16px;
      outline: none;
      border: none;
      font-size: 0.95rem;
      color: ${colors.text};
      
      ::placeholder {
        color: #999;
      }
    }
  }
  input,
  textarea {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f8f9fa;
    width: 100%;
    padding: 12px 16px;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: #999;
    }
  }
  span {
    background-color: ${colors.inputWhite};
    padding: 1em 0em 1em 1em;
    border-radius: 5px;
    border: 1px solid ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    label {
      position: absolute;
      right: 3%;
      top: 20%;
      background-color: ${colors.black};
      color: ${colors.white};
      padding: 0.5em 1em;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: clamp(1em, 1vh, 2em);
      color: ${colors.textMed};
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  gap: 1rem;
  
  .cancel-btn {
    background: #6c757d;
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      background: #5a6268;
      box-shadow: 0 8px 20px rgba(108, 117, 125, 0.3);
    }
    
    &:active {
    }
  }
  
  .save-btn {
    background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
    color: ${colors.white};
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    min-width: 120px;
    outline: none;
    flex: 1;
    max-width: 200px;
    
    &:hover {
      box-shadow: 0 8px 20px rgba(36, 147, 147, 0.3);
    }
    
    &:active {
    }
  }
`;

const TaskLoader = styled.div`
  margin-top: 1em;
`;

const BankInputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.black};
    font-size: clamp(1em, 1vw, 2em);
    margin: 1em 0em;
  }
`;

const UploadedFile = styled.img`
  border-radius: 50%;
  margin-left: 50%;
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const StaffInputFeild = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  
  h3 {
    color: ${colors.text};
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 0.75rem 0;
  }
`;


const Feedback = styled.div`
button{
  background-color: ${colors.brown};
  color: ${colors.white};
  border: none;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
}
`